import gql from "graphql-tag";

export const CANCEL_ADDON_SUBSCRIPTION_MUTATION = gql`
  mutation($subscription_id: ID!) {
    cancelAddOnSubscription(subscription_id: $subscription_id) {
      id
    }
  }
`;
